import 'css-vars-ponyfill';
import 'intersection-observer';
import TagManager from 'react-gtm-module';
import Cookies from 'js-cookie';
import '@drdropin-tech/theseus/lib/tailwind.css';
import './src/styles/tailwind.css';
import posthog from 'posthog-js';

// These css files needs to stay in this order
import './src/static/fonts.css';
import './src/static/base.css';
import DEPLOYMENT_URL from './src/utils/getDeploymentUrl';

const gtmId = process.env.GATSBY_GOOGLE_TAGMANAGER_ID;

if (
  Cookies.get('gatsby-gdpr-google-analytics') === 'true' &&
  process.env.GATSBY_ENV === 'production'
) {
  if (gtmId) {
    TagManager.initialize({
      gtmId,
    });
  }
}

if (
  Cookies.get('gatsby-gdpr-posthog') === 'true' &&
  process.env.GATSBY_ENABLE_POSTHOG
) {
  posthog.init(process.env.GATSBY_POSTHOG_APP_ID, {
    api_host: new URL('/ingest', DEPLOYMENT_URL).toString(),
    ui_host: 'https://eu.posthog.com',
    autocapture: true,
    capture_pageview: true,
  });
}

// eslint-disable-next-line
export { default as wrapPageElement } from './src/providers/wrapPageElement';
